import React from 'react';
import { SkeletonThumbnail, SkeletonGroup } from '@shared/components/Skeleton';
import { pxToRem } from '@withjoy/joykit/theme';

const skeletonOverrides = { Root: { props: { boxShadow: `0px 7px 27px 0px rgba(44, 41, 37, 0.06), 0px 4px 16px 0px rgba(0, 0, 0, 0.07)`, borderRadius: pxToRem(12) } } };

const PhotoCardSkeleton = ({ height = 240 }: { height?: number }) => {
  return (
    <>
      <SkeletonThumbnail
        borderRadius={3}
        overrides={{
          PlaceholderRoot: {
            props: {
              width: '100%',
              height: pxToRem(height),
              backgroundColor: 'white',
              borderRadius: pxToRem(12),
            },
          },
        }}
      />
    </>
  );
};

interface PhotoCardSkeletonGroupProps
  extends Readonly<{
    loading: boolean;
    count?: number;
    height?: number;
  }> {}

export const PhotoCardSkeletonGroup: React.FC<PhotoCardSkeletonGroupProps> = ({ loading, count = 3, height = 240 }) => {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <SkeletonGroup
          key={i}
          isReady={loading}
          width="100%"
          height="100%"
          placeholder={<PhotoCardSkeleton height={height} />}
          overrides={skeletonOverrides}
        >
          <PhotoCardSkeleton height={height} />
        </SkeletonGroup>
      ))}
    </>
  );
};

export const PhotoCardSingleSkeleton: React.FC<PhotoCardSkeletonGroupProps> = ({ loading, height = 240 }) => {
  return (
    <SkeletonGroup
      isReady={loading}
      width="100%"
      height="100%"
      placeholder={<PhotoCardSkeleton height={height} />}
      overrides={skeletonOverrides}
    >
      <PhotoCardSkeleton height={height} />
    </SkeletonGroup>
  );
};
